
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Hash, TrendingUp } from 'lucide-react';

const ContentTips: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Content Tips</CardTitle>
        <CardDescription>AI recommendations for better engagement</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex gap-2 items-start">
          <TrendingUp className="h-4 w-4 text-green-500 mt-0.5" />
          <p className="text-sm">Use 3-5 highly relevant hashtags rather than dozens of generic ones</p>
        </div>
        
        <div className="flex gap-2 items-start">
          <TrendingUp className="h-4 w-4 text-green-500 mt-0.5" />
          <p className="text-sm">Ask questions in your captions to encourage comments and boost algorithm visibility</p>
        </div>
        
        <div className="flex gap-2 items-start">
          <TrendingUp className="h-4 w-4 text-green-500 mt-0.5" />
          <p className="text-sm">Share authentic behind-the-scenes content to build stronger connections with fans</p>
        </div>
        
        <div className="flex gap-2 items-start">
          <TrendingUp className="h-4 w-4 text-green-500 mt-0.5" />
          <p className="text-sm">Optimal posting times: Instagram (12-2pm), TikTok (7-9pm), Twitter (8-10am)</p>
        </div>
        
        <Button variant="outline" className="w-full mt-2">
          <Hash className="h-4 w-4 mr-1" />
          Get Trending Hashtags
        </Button>
      </CardContent>
    </Card>
  );
};

export default ContentTips;
